"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// prettier-ignore
exports.default = {
    "totalRecords": 1,
    "skip": 0,
    "take": 100,
    "recordsReturned": 1,
    "data": [
        {
            "accountNumber": "SA0613",
            "name": "1000 Super",
            "type": "Super"
        }
    ]
};
